import React from 'react';
import { useOnChildrenRendered, Item } from '@rmc/webcx-web-libs';
import {
	AppUserInterfacePropsT,
	WebBlocksApiComponentT,
} from '../../lib/REST/types';

function getComponentList(component: WebBlocksApiComponentT) {
	if (component.type !== 'template') {
		return [component];
	}
	const { children } = component.props;

	return Array.isArray(children) ? children : [children];
}

export function AppUserInterface({
	component,
	clickLinkData,
	onRendered = () => {},
}: AppUserInterfacePropsT) {
	const componentList = getComponentList(component);

	const { onItemRendered } = useOnChildrenRendered({
		onAllChildrenRendered: onRendered,
		componentList,
	});

	return (
		<>
			{componentList.map((t, index) => (
				<Item
					clickLinkData={clickLinkData}
					element={t}
					// eslint-disable-next-line react/no-array-index-key
					key={`${index}`}
					onRendered={onItemRendered(index)}
				/>
			))}
		</>
	);
}
